import { useState, useEffect } from 'react';

// Check once at module load time
const isCapacitorApp = typeof window !== 'undefined' && (
  !!window.Capacitor || 
  navigator.userAgent.includes('Capacitor') ||
  document.URL.includes('capacitor://') ||
  document.URL.includes('localhost') === false
);

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    
    // If we're in Capacitor, always mobile
    if (isCapacitorApp) return true;
    
    // Check user agent
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true;
    }
    
    // Fallback to screen width
    return window.innerWidth <= 768;
  });

  useEffect(() => {
    // If Capacitor, always stay mobile
    if (isCapacitorApp) {
      setIsMobile(true);
      return;
    }

    const checkMobile = () => {
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setIsMobile(isMobileDevice || window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile;
}

export function useIsCapacitor() {
  return isCapacitorApp;
}

export default useIsMobile;
